export default "__VITE_ASSET__B8usoe0r__"